import { render, staticRenderFns } from "./v-media-vr.vue?vue&type=template&id=9edd82a8&scoped=true&"
import script from "./v-media-vr.vue?vue&type=script&lang=js&"
export * from "./v-media-vr.vue?vue&type=script&lang=js&"
import style0 from "./v-media-vr.vue?vue&type=style&index=0&id=9edd82a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edd82a8",
  null
  
)

export default component.exports